import { Box } from "@mui/material";

import { PostMediaProps } from "../../../../types/components/props.type";

import PostMediaLayout from "./PostMediaLayout";

const PostMedia = ({ media, onClickOnMedia }: PostMediaProps) => {
  if (!media || media.length === 0) return null;

  const visibleMedia = media.slice(0, 5);
  const extraMediaCount = Math.max(0, media.length - 5);

  return (
    <Box
      sx={{
        width: "100%",
        aspectRatio: "1 / 1",
        overflow: "hidden",
      }}
    >
      <PostMediaLayout visibleMedia={visibleMedia} extraMediaCount={extraMediaCount} onClickOnMedia={onClickOnMedia} />
    </Box>
  );
};

export default PostMedia;
